import { isNullOrUndefined } from "../../../common/utils";

export function findConditionById(conditionNode, id) {
  if (isNullOrUndefined(conditionNode)) {
    return null;
  }
  if (conditionNode.key === id) {
    return conditionNode;
  }
  if (conditionNode.isSingleOperand() === false) {
    let foundNode;
    const operands = conditionNode.getOperands();
    for (let count = 0; count < operands.length; count++) {
      foundNode = findConditionById(operands[count], id);
      if (!isNullOrUndefined(foundNode)) {
        return foundNode;
      }
    }
  }
  return null;
}
